const PriceMaybe = () => null;

export default PriceMaybe;
